/**
 * Mermaid Tool - 狀態管理
 * static/js/mermaid/state.js
 */

/**
 * 建立應用程式狀態物件
 * @returns {Object} 狀態物件
 */
export function createState() {
    return {
        // 當前圖表資訊
        currentDiagramId: null,
        currentDiagramType: 'flowchart',
        hasUnsavedChanges: false,
        
        // Canvas 狀態
        canvasZoom: 1,
        canvasPanX: 0,
        canvasPanY: 0,
        isPanning: false,
        panStartX: 0,
        panStartY: 0,
        
        // 渲染狀態
        renderTimeout: null,
        isRendering: false,
        lastRenderCode: '',
        
        // Panel resizer 狀態
        isResizing: false,
        resizeStartX: 0,
        resizeStartWidth: 0
    };
}

// 全域狀態實例
let state = createState();

/**
 * 獲取當前狀態
 * @returns {Object} 當前狀態物件
 */
export function getState() {
    return state;
}

/**
 * 更新狀態
 * @param {Object} updates - 要更新的鍵值對
 */
export function updateState(updates) {
    Object.assign(state, updates);
}

/**
 * 重置狀態到初始值
 */
export function resetState() {
    state = createState();
}

/**
 * 標記為有未儲存變更
 */
export function markUnsaved() {
    state.hasUnsavedChanges = true;
}

/**
 * 標記為已儲存
 */
export function markSaved() {
    state.hasUnsavedChanges = false;
}

/**
 * 設定當前圖表 ID
 * @param {number|null} id - 圖表 ID
 */
export function setCurrentDiagramId(id) {
    state.currentDiagramId = id;
}

/**
 * 獲取當前圖表 ID
 * @returns {number|null}
 */
export function getCurrentDiagramId() {
    return state.currentDiagramId;
}

/**
 * 檢查是否有未儲存變更
 * @returns {boolean}
 */
export function hasUnsavedChanges() {
    return state.hasUnsavedChanges;
}
